import { useCallback, useContext, useMemo } from "react"
import {
  Button,
  ButtonProps,
  IconProps,
  LogIn01,
  Plus,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import {
  resetDepositState,
  selectIsConnected,
  setOpenModal,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { IS_MEZO_MAINNET, routes } from "#/shared/constants"
import { FlowContext } from "#/shared/context"

export default function MatsEmptyStateButton() {
  const isConnected = useDappSelector(selectIsConnected)
  const dispatch = useDappDispatch()

  const { flow } = useContext(FlowContext)
  const [, theme] = useStyletron()

  const canDeposit = useMemo(
    () => isConnected && !IS_MEZO_MAINNET,
    [isConnected],
  )

  const buttonClickHandler = useCallback(() => {
    if (canDeposit) {
      dispatch(resetDepositState({ flow }))
    } else {
      dispatch(setOpenModal("onboarding"))
    }
  }, [canDeposit, dispatch, flow])

  const buttonIcon = useMemo(() => {
    const iconProps: IconProps = {
      color: theme.colors.white,
      size: theme.sizing.scale600,
    }

    return canDeposit ? <Plus {...iconProps} /> : <LogIn01 {...iconProps} />
  }, [canDeposit, theme])

  const buttonProps: ButtonProps = {
    size: "medium",
    onClick: buttonClickHandler,
    startEnhancer: buttonIcon,
    overrides: { BaseButton: { style: () => ({ width: "140px" }) } },
    ...(canDeposit
      ? { $as: Link, href: `${routes.DEPOSIT}?tab=new-deposit` }
      : {}),
  }

  if (isConnected && IS_MEZO_MAINNET) return null

  return <Button {...buttonProps}>{canDeposit ? "Deposit" : "Sign in"}</Button>
}
